
import Dashboard from "views/Dashboard.js";
import ModernDashboard from "views/ModernDashboard";
import Notifications from "views/Notifications.js";
import Support from "views/Support";
import TransactionHistory from "views/TransactionHistory";
import Settings from "views/Settings";
import VirtualCards from "views/VirtualCards/VirtualCards";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "📊",
    component: <ModernDashboard />,
    layout: "/user",
  },
  {
    path: "/virtual-cards",
    name: "Virtual Cards",
    icon: "🪪",
    component: <VirtualCards />,
    layout: "/user",
  },
  {
    path: "/tables",
    name: "Transaction",
    icon: "💳",
    component: <TransactionHistory />,
    layout: "/user",
  },
  {
    path: "/user-page",
    name: "Settings",
    icon: "⚙️",
    component: <Settings />,
    layout: "/user",
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "🔔",
    component: <Notifications />,
    layout: "/user",
  },
  {
    path: "/support",
    name: "Support",
    icon: "💬",
    component: <Support />,
    layout: "/user",
  }
];
export default routes;
